import { CSSProperties, FC } from "react";
import { SearchBarButtonContainerStyling } from "./TableElements.styles";
import EditBtn from "./EditBtn";
import SaveBtn from "./SaveBtn";
import CreateBtn from "./CreateBtn";
import BulkDownloadOnboardingFilesButton from "../../../pages/employees/EmployeesTable/BulkDownloadOnboardingFilesButton";
import FileUploaderBox from "../../../pages/employees/EmployeesTable/FileUploaderBox";

interface SearchBarButtonContainerProps {
    onCreateClick?: () => void;
    onEditClick?: () => void;
    onSaveClick?: () => void;
    createMode?: boolean;
    showBulkDownloadButton?: boolean;
    showFileUploaderBox?: boolean;
    style?: CSSProperties;
}

const SearchBarButtonContainer: FC<SearchBarButtonContainerProps> = ({
    onCreateClick,
    onEditClick,
    onSaveClick,
    createMode = false,
    showBulkDownloadButton = false,
    showFileUploaderBox = false,
    style
}) => {
    return (
        <SearchBarButtonContainerStyling style={style}>
            {showBulkDownloadButton && <BulkDownloadOnboardingFilesButton />}
            {onCreateClick && <CreateBtn handleOnClick={onCreateClick} adding={!createMode} />}
            {onEditClick && <EditBtn handleOnClick={onEditClick} />}
            {onSaveClick && <SaveBtn handleOnClick={onSaveClick} />}
            {showFileUploaderBox && <FileUploaderBox />}
        </SearchBarButtonContainerStyling>
    );
};

export default SearchBarButtonContainer;